import React from 'react';
import ReactDOM from 'react-dom/client';
import '@argink/ui/styles.css';
import './styles/app.css';
import './styles/tenant.css';
import './styles/product-preview.css';
import './styles/app-window.css';
import './styles/public-home.css';
import { App } from './App';

/**
 * Mocks só em dev, nunca em produção (AMVP-08 real chega via F04/I2). Guardado
 * atrás de `import.meta.env.DEV` — o Vite elimina este bloco inteiro (e o import
 * dinâmico de `./mocks/browser`) do bundle de produção por dead-code elimination,
 * então `src/mocks/**` nunca viaja pro build final. Ligado por padrão em dev
 * (ainda não há backend real integrado nesta frente); `VITE_USE_MOCKS=false`
 * desliga quando apontar para `apps/api` de verdade.
 */
async function bootstrap() {
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS !== 'false') {
    const { installMockFetch } = await import('./mocks/browser');
    installMockFetch();
  }

  const rootEl = document.getElementById('root');
  if (!rootEl) {
    throw new Error('elemento #root não encontrado em index.html');
  }

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
